import { IPaymentCard } from '@/components/IBPayment/interface';
import Redirect from '@/mixins/redirect/redirect';
import { Component, Mixins } from 'vue-property-decorator';
import { PaymentRequirementsItem } from '../../../api/incoming/payment-requirements-incoming.interface';
import PaymentRequirementsMapToUZSPayment from '../Unprocessed/PaymentRequirementsMapToUZSPayment';

@Component
export default class PaymentRequirementsCardActions extends Mixins(
	Redirect,
	PaymentRequirementsMapToUZSPayment
) {

	paymentRequirementsDenieHandlerDialog: boolean = false

	paymentRequirementsForDenie: PaymentRequirementsItem | null = null

	deniePaymentRequirementsCard(
		paymentCard: IPaymentCard<PaymentRequirementsItem | null>
	) {
		if (!paymentCard.meta) return;

		this.paymentRequirementsForDenie = paymentCard.meta;
		this.paymentRequirementsDenieHandlerDialog = true;
	}

	payPaymentRequirementsCard(
		paymentCard: IPaymentCard<PaymentRequirementsItem | null>
	) {
		if (!paymentCard.meta) return;

		sessionStorage.setItem('sumPayment', JSON.stringify(
			this.mapPaymentRequirementsToUZSPayment(
				paymentCard.meta
			)
		));

		this.redirectTo(
			'paymentRequirementsIncomingPay', {
				paymentRequirementsIncoming: paymentCard.meta,
				backRoute: {
					name: this.$route.name,
					params: this.$route.params
				},
			}
		);
	}

}